export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Łącznie do pobrania"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prowizja"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Info"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Do uznania"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nie można obliczyć kwoty"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Niewystarczające środki na płatność"])}
}